import { ChangeAlertCallbackType } from "../components/Root";
import { getPosition } from "./PositionService";
import * as API from '../http/api';

export class AlboQueryService {
    private changeAlert: ChangeAlertCallbackType
    constructor(changeAlert: ChangeAlertCallbackType) {
        this.changeAlert = changeAlert
    }
      
    async executeQuery(data) {
        const pos = getPosition();
        const response = await API.service('alboQueryLanguaje', data, pos, this.changeAlert, null, null);

        return response?.data
    }
}